export const LOAD_NEWS = 'news/LOAD';
export const LOAD_NEWS_COMPLETE = 'news/LOAD_COMPLETE';
export const LOAD_DETAIL_NEW = 'news/LOAD_DETAIL';
export const LOAD_DETAIL_NEW_COMPLETE = 'news/LOAD_DETAIL_COMPLETE';
export const LOAD_MORE_NEWS = 'news/LOAD_MORE_NEWS';
export const LIKE_NEWS = 'news/LIKE_NEWS';
export const UNLIKE_NEWS = 'news/UNLIKE_NEWS';
export const COMMENT_NEWS = 'news/COMMENT_NEWS';
export const FAVORITE_NEWS = 'news/FAVORITE_NEWS';
export const UNFAVORITE_NEWS = 'news/UNFAVORITE_NEWS';
export const SEND_NEWS = 'news/SEND_NEWS';
export const ADVICE_MORE_NEWS = 'news/ADVICE_MORE_NEWS';
export const LOAD_NEWS_STICKY = 'news/LOAD_NEWS_STICKY';
export const LOAD_NEWS_STICKY_COMPLETE = 'news/LOAD_NEWS_STICKY_COMPLETE';
export const LOAD_NEWS_HIGHLIGHT = 'news/LOAD_NEWS_HIGHLIGHT';
export const LOAD_NEWS_HIGHLIGHT_COMPLETE = 'news/LOAD_NEWS_HIGHLIGHT_COMPLETE';
export const LOAD_COMMENTS = 'news/LOAD_COMMENTS';
export const LOAD_COMMENTS_COMPLETE = 'news/LOAD_COMMENTS_COMPLETE';
export const INSERT_COMMENT = 'news/INSERT_COMMENT';
export const REPLY_COMMENT = 'news/REPLY_COMMENT';
export const DELETE_COMMENT = 'news/DELETE_COMMENT';
export const LOAD_ALL_REPLIES_COMMENT = 'news/LOAD_ALL_REPLIES_COMMENT';
export const CHANGE_PAGE_COMMENTS = 'news/CHANGE_PAGE_COMMENTS';
